import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyCqp4vk4Bf4Stme-2fT9bJsPt4TozvQ2W8',
  authDomain: 'health-jorney.firebaseapp.com',
  projectId: 'health-jorney',
  storageBucket: 'health-jorney.firebasestorage.app',
  messagingSenderId: '779259686482',
  appId: '1:779259686482:web:30c806da61bdd7a6bcb98b',
  measurementId: 'G-731Z60B1QY',
};

const emulatorUrl = process.env.FIREBASE_AUTH_EMULATOR_URL;

const app = initializeApp(emulatorUrl ? { ...firebaseConfig, projectId: 'demo-hhealth' } : firebaseConfig);
export const auth = getAuth(app);

if (emulatorUrl) {
  connectAuthEmulator(auth, emulatorUrl, { disableWarnings: true });
}

// Initialize Analytics only in production and if supported
export let analytics: ReturnType<typeof getAnalytics> | null = null;

if (process.env.NODE_ENV === 'production') {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}

export function trackEvent(eventName: string, params?: Record<string, string | number | boolean>) {
  if (analytics) {
    logEvent(analytics, eventName, params);
  } else if (process.env.NODE_ENV !== 'production') {
     
    console.debug(`[Analytics Event]: ${eventName}`, params || {});
  }
}
